module.exports = __webpack_public_path__ + "img/kangbaotong.a6f23696.jpeg";